module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-RegularItalic-WebS.6b011486.eot";